<template>
    <!--父级路由和子级路由的选择-->
    <router-view v-if="$route.path !== '/purhistory'"></router-view>
    <div class="shortcut-box" ref="scrollableDiv" v-else>
        <!-- 筛选栏 -->
        <div class="person-info">
            <div class="contact-me" id="contact">
                <h1 class="big-title">筛选条件: {{ $route.query.stickcode }}</h1>
                <div class="tiptop">
                    <el-tooltip class="box-item" effect="dark" content="Top Center prompts info" placement="top">
                        <template #content>
                            填入【验机码】后,【回车】就能【自动填入】手机信息筛选条件<br />【双击】快速复制【验机码】,点击【查询】呈现出结果
                            <br />点击右下方【数据刷新】可以清除验机码
                        </template>
                        <el-icon>
                            <QuestionFilled />
                        </el-icon>
                    </el-tooltip>
                </div>
                <!-- <ul>
                    <li>填入【验机码】后,【回车】就能【自动填入】手机信息筛选条件</li>
                    <li>【双击】快速复制【验机码】,点击【查询】呈现出结果</li>
                    <li>点击右下方【数据刷新】可以清除验机码</li>
                </ul> -->
                <div class="text-center-row">
                    <div class="row">
                        <div class="form-group">
                            <!-- 手机信息 -->
                            <div class="input-group">
                                <!-- 选择平台 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select1' }">
                                    <input class="input" type="text" readonly :value="sourceSelect" placeholder="选择平台--全选" @click="toggleOptions('select1')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select1')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(items, index) in selectdata.data.sourcesList"
                                            :key="index"
                                            @click="selectOption(items, 'select1')"
                                            :title="items">
                                            &nbsp;{{ items }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 选择等级 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select2' }">
                                    <input class="input" type="text" readonly :value="gradeSelect" placeholder="选择等级--全选" @click="toggleOptions('select2')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select2')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.gradeList"
                                            :key="index"
                                            @click="selectOption(option, 'select2')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 选择品牌 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select3' }">
                                    <input class="input" type="text" readonly :value="brandSelect" placeholder="选择品牌--全选" @click="toggleOptions('select3')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select3')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.brandList"
                                            :key="index"
                                            @click="selectOption(option, 'select3')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <div class="custom-select" :class="{ open: isOpen === 'select4' }">
                                    <input class="input" type="text" readonly :value="modelSelect" placeholder="选择型号--全选" @click="toggleOptions('select4')" />
                                    <div class="options" v-if="selectbrand && selectbrand.success">
                                        <div class="option" @click="allselect('select4')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbrand.data.modelList"
                                            :key="index"
                                            @click="selectOption(option, 'select4')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <div class="custom-select" :class="{ open: isOpen === 'select5' }">
                                    <input class="input" type="text" readonly :value="colorSelect" placeholder="选择颜色--全选" @click="toggleOptions('select5')" />
                                    <div class="options" v-if="selectbasicinfo && selectbasicinfo.success">
                                        <div class="option" @click="allselect('select5')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbasicinfo.data.colorList"
                                            :key="index"
                                            @click="selectOption(option, 'select5')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <div class="custom-select" :class="{ open: isOpen === 'select6' }">
                                    <input class="input" type="text" readonly :value="capacitySelect" placeholder="选择容量--全选" @click="toggleOptions('select6')" />
                                    <div class="options" v-if="selectbasicinfo && selectbasicinfo.success">
                                        <div class="option" @click="allselect('select6')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbasicinfo.data.capacityList"
                                            :key="index"
                                            @click="selectOption(option, 'select6')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- todo 选择成色 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select7' }">
                                    <input class="input" type="text" readonly :value="conditonSelect" placeholder="选择成色--全选" @click="toggleOptions('select7')" />
                                    <div class="options">
                                        <div class="option" @click="allselect('select7')">&nbsp;全选</div>
                                        <div class="option" v-for="(option, index) in conditons" :key="index" @click="selectOption(option, 'select7')" :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 价格 -->
                            <div class="input-group">
                                <div class="custom-select" :class="{ open: isOpen === 'select8' }">
                                    <input class="input" type="number" @keypress="preventE" v-model="lowpriceSelect" placeholder="最低成交价格" />
                                </div>

                                <div class="custom-select" :class="{ open: isOpen === 'select9' }">
                                    <input class="input" type="number" @keypress="preventE" v-model="highpriceSelect" placeholder="最高成交价格" />
                                </div>

                                <!-- 是否拍卖成功 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select10' }">
                                    <input class="input" type="text" readonly :value="buysuccessSelect" placeholder="是否买到--全选" @click="toggleOptions('select10')" />
                                    <div class="options">
                                        <div class="option" @click="selectOption(null, 'select10')">&nbsp;全选</div>
                                        <div class="option" @click="selectOption('是', 'select10')">&nbsp;是</div>
                                        <div class="option" @click="selectOption('否', 'select10')">&nbsp;否</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="button">
                    <button class="btn" @click="menuselect()">查询</button>
                    <button class="btn" @click="resetSelection()">重选</button>
                </div>

                <form>
                    <input type="radio" disabled id="option1" name="options" value="option1" />
                    <!-- 默认选中第一个选项 -->
                    <label for="option1">仅查看本账号</label><br />
                    <input type="radio" id="option2" name="options" value="option2" checked />
                    <label for="option2">查看所有记录</label><br />
                </form>
            </div>
        </div>
        <hr style="width: 95%; margin-top: 0" />
        <section class="section">
            <!-- 分页控件 -->
            <!-- todo 将分页控件放在 页尾 -->
            <div class="pagination">
                <nav v-if="allpages >= 1">
                    <ul class="pagination">
                        <!-- 首页按钮 -->
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="#" @click.prevent="gotoPage(1)">首页</a>
                        </li>

                        <!-- 上一页按钮 -->
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="#" @click.prevent="prevPage()">上一页</a>
                        </li>

                        <!-- 页码按钮 -->
                        <li
                            v-for="page in visiblePages"
                            :key="page"
                            class="page-item"
                            :class="{
                                active: page === currentPage,
                                disabled: page === '...',
                            }">
                            <a class="page-link" href="#" @click.prevent="gotoPage(page)" v-if="page !== '...'">{{ page }}</a>
                            <span v-else>{{ page }}</span>
                        </li>

                        <!-- 下一页按钮 -->
                        <li class="page-item" :class="{ disabled: currentPage === allpages }">
                            <a class="page-link" href="#" @click.prevent="nextPage()">下一页</a>
                        </li>

                        <!-- 尾页按钮 -->
                        <li class="page-item" :class="{ disabled: currentPage === allpages }">
                            <a class="page-link" href="#" @click.prevent="gotoPage(allpages)">尾页</a>
                        </li>

                        <li>
                            <!-- 跳转到具体页码的输入框 -->
                            <div>
                                <label for="gotoPageInput"><span style="color: white">跳至：</span></label>
                                <input type="number" id="gotoPageInput" v-model.number="gotoPageNumber" min="1" :max="allpages" />
                                <button @click="gotoSpecificPage">go</button>
                            </div>
                        </li>

                        <li>
                            <!-- 每页数据量大小 -->
                            <label for="itemsPerPageSelect"><span style="color: white">每页展示:</span></label>
                            <select id="itemsPerPageSelect" v-model="itemsPerPage">
                                <option value="1" selected>1 条</option>
                                <option value="5">5 条</option>
                                <option value="10">10 条</option>
                                <option value="20">20 条</option>
                                <option value="50">50 条</option>
                                <option value="100">100 条</option>
                                <option value="500">500 条</option>
                            </select>
                        </li>
                    </ul>
                </nav>
            </div>
            <!-- 标题 -->
            <div class="header">
                <span>
                    <h2>历史暗拍页</h2>
                    <div class="histop">
                        <el-tooltip class="box-item" effect="dark" content="Top Center prompts info" placement="top">
                            <template #content>
                                在这里你可以了解各种快捷操作，我们会帮助你快速定位所需的产品。<br />【拍卖场更新的数据添加在最后;
                                <br />数据刷新是对本场所有数据的刷新;<br />如果需要对特定条件数据刷新,点击查询即可
                            </template>
                            <el-icon>
                                <QuestionFilled />
                            </el-icon>
                        </el-tooltip>
                    </div>
                    <!-- <h6>
                        在这里你可以了解各种快捷操作，我们会帮助你快速定位所需的产品。<br />
                        拍卖场更新的数据添加在最后;<br />
                        数据刷新是对本场所有数据的刷新;<br />
                        如果需要对特定条件数据刷新,点击查询即可
                    </h6> -->
                </span>
            </div>
            <div v-if="error" class="error-message">{{ error }}</div>

            <!-- 数据页 -->
            <div v-if="data">
                <div v-if="data.success">
                    <div v-if="data.data.result && data.data.result.length > 0">
                        <!-- 详情页弹窗 -->
                        <div class="overlay" id="overlay" @click="closePopup()" @keydown.esc="closePopup()">
                            <div class="popup" @click.stop>
                                <span class="close-btn" @click="closePopup()" style="color: black; background-color: #babebf">关闭X</span>
                                <div>
                                    <detailsCardView ref="detailsCardView"></detailsCardView>
                                </div>
                            </div>
                        </div>
                        <!-- 列表 -->
                        <ul class="services">
                            <div v-for="(item, index) in data.data.result" :key="index" class="item">
                                <li class="services__item" @click="selectItem(item)">
                                    <h3>
                                        {{ item.model }} {{ item.color }}
                                        {{ item.grade }}
                                        <span v-if="item.ram">{{ item.ram }}+</span>{{ item.storage }}
                                    </h3>
                                    <p style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis" :title="parseQualityDesc(item.qualityDesc)">
                                        {{ item.sources }}
                                        {{ item.authorization }} 起拍价:
                                        <span style="color: white; background-color: red; border-radius: 9px">¥{{ item.upsetPrice }}</span>
                                        成交价:
                                        <span style="color: white; background-color: green; border-radius: 9px">¥{{ item.transactionPrice }}</span>
                                        {{ item.purchaseChannel }}
                                        {{ parseQualityDesc(item.qualityDesc) }}
                                    </p>
                                    <p>场次:{{ item.patch }} 验机码:{{ item.stickCode }}</p>
                                </li>
                            </div>
                        </ul>
                        <div class="pagination">
                            <nav v-if="allpages >= 1">
                                <ul class="pagination">
                                    <!-- 上一页按钮 -->
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="#" @click.prevent="prevPage()">上一页</a>
                                    </li>
                                    <!-- 下一页按钮 -->
                                    <li
                                        class="page-item"
                                        :class="{
                                            disabled: currentPage === allpages,
                                        }">
                                        <a class="page-link" href="#" @click.prevent="nextPage()">下一页</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div v-else-if="typeof patch === 'undefined'">
                        <span style="color: white">{{ data }}</span>
                    </div>
                    <div v-else-if="patch !== null">
                        {{ shownofoundAlert() }}
                        <span style="color: white">{{ data }}</span>
                    </div>
                </div>
                <div v-else>
                    <p class="error-message">获取数据失败: {{ data.message }}</p>
                </div>
            </div>
        </section>
        <FixedButtons @scroll-to-top="scrollToTop" />
    </div>
</template>

<script>
    import detailsCardView from "@/components/detailsCardView.vue";
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";
    import { ElMessage } from "element-plus";
    import { mapActions } from "vuex";

    export default {
        components: { detailsCardView, FixedButtons },
        data() {
            return {
                // 下拉框数据
                conditons: ["开发中,成色不可用"],

                isOpen: false,
                isAll: 1,

                historyDataURL: "/api/historyAuction/queryHistoryAuctionInfo",
                historyMenuURL: "/api/historyAuction/init",

                item: "",
                data: null,
                error: null,
                urlCarry: null,

                currentPage: 1, // 当前页码
                itemsPerPage: 20, // 每页显示条目数
                maxVisiblePages: 5, // 最多显示的页码数量
                gotoPageNumber: 1, // 用来存储用户输入的页码
                allpages: 1, // 总页数
                datatogo: "", // 要向vuex传递的数据

                // 下面菜单筛选需要的数据
                // 下拉框的备选值
                selectdata: null,
                selectsource: null,
                selectbrand: null,
                selectmodel: null,
                selectbasicinfo: null,
                lowpriceSelect: null,
                highpriceSelect: null,

                // 下拉框的选定值
                sourceSelect: null,
                gradeSelect: null,
                brandSelect: null,
                modelSelect: null,
                colorSelect: null,
                capacitySelect: null,
                conditonSelect: null,
                buysuccessSelect: null,

                // 右侧滚轮
                scrollableDiv: null,
            };
        },
        watch: {
            // 当每页展示条目数量改变时，重新计算总页数并更新当前页码
            itemsPerPage() {
                // 返回第一页
                this.currentPage = 1;
                // 重新从服务器获取数据等
                this.menuselect();
            },
            "$route.query.stickcode": {
                handler(newVal) {
                    this.urlCarry = this.$route.query.stickcode;
                    if (newVal) {
                        this.menuselect();
                    } else {
                        this.getinitData();
                    }
                },
                immediate: true, // 立即触发一次监听器，可以根据实际需求选择是否需要
            },
        },
        computed: {
            // 计算总页数
            totalPages() {
                return this.allpages;
            },

            // 根据当前页码和可见页码范围计算当前显示的页码数组
            visiblePages() {
                const pages = [];
                const totalPageCount = this.totalPages;
                const maxPages = this.maxVisiblePages;
                const currentPage = this.currentPage;

                if (totalPageCount <= maxPages) {
                    for (let i = 1; i <= totalPageCount; i++) {
                        pages.push(i);
                    }
                } else {
                    let left = Math.max(1, currentPage - Math.floor(maxPages / 2));
                    let right = Math.min(totalPageCount, left + maxPages - 1);

                    if (right - left + 1 < maxPages) {
                        left = Math.max(1, right - maxPages + 1);
                    }

                    for (let i = left; i <= right; i++) {
                        pages.push(i);
                    }

                    if (left > 1) {
                        pages.unshift("...");
                        pages.unshift(1);
                    }
                    if (right < totalPageCount) {
                        pages.push("...");
                        pages.push(totalPageCount);
                    }
                }
                return pages;
            },
        },
        mounted() {
            // 需要回到顶部的div
            this.scrollableDiv = this.$refs.scrollableDiv;
        },
        // 进入页面时就获取数据
        // beforeRouteEnter(to, from, next) {
        //     next((vm) => {
        //         vm.getinitData();
        //     });
        // },
        methods: {
            // 页面回到顶部
            scrollToTop() {
                this.scrollableDiv.scrollTo({
                    top: 0,
                    behavior: "auto",
                });
            },
            // 下面是下拉框下拉展示方法
            toggleOptions(selectId) {
                if (this.isOpen === selectId) {
                    this.isOpen = null;
                } else {
                    this.isOpen = selectId;
                }
            },
            // 下拉选择,确定选项值
            selectOption(option, selectId) {
                // 选择来源
                if (selectId === "select1") {
                    this.sourceSelect = option;
                } else if (selectId === "select2") {
                    this.gradeSelect = option;
                } else if (selectId === "select3") {
                    this.brandSelect = option;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = option;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.colorSelect = option;
                } else if (selectId === "select6") {
                    this.capacitySelect = option;
                } else if (selectId === "select7") {
                    this.conditonSelect = option;
                } else if (selectId === "select10") {
                    this.buysuccessSelect = option;
                }
                this.isOpen = null;
            },
            // 全选--默认
            allselect(selectId) {
                if (selectId === "select1") {
                    this.sourceSelect = null;
                    this.isOpen = null;
                } else if (selectId === "select2") {
                    this.gradeSelect = null;
                    this.isOpen = null;
                } else if (selectId === "select3") {
                    this.brandSelect = null;
                    this.isOpen = null;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = null;
                    this.isOpen = null;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.isOpen = null;
                    this.colorSelect = null;
                } else if (selectId === "select6") {
                    this.isOpen = null;
                    this.capacitySelect = null;
                } else if (selectId === "select7") {
                    this.isOpen = null;
                    this.conditonSelect = null;
                }
            },
            // 上面是下拉框

            // 打开详情页
            openPopup() {
                document.getElementById("overlay").style.display = "block";
            },
            // 关闭详情页
            closePopup() {
                if (this.$refs.detailsCardView) {
                    // 在调用之前检查 selectTab 方法是否存在
                    if (typeof this.$refs.detailsCardView.selectTab === "function") {
                        this.$refs.detailsCardView.selectTab(1);
                    } else {
                        console.error("子组件中未定义 selectTab 方法");
                    }
                } else {
                    console.error("子组件引用尚未可用");
                }
                document.getElementById("overlay").style.display = "none";
            },

            // 显示弹窗
            // 向vuex传递数据
            selectItem(item) {
                this.updateSharedData(item);
                this.openPopup();
            },
            ...mapActions("shared",["updateSharedData"]),
            updateData(item) {
                this.updateSharedData(item);
            },

            // 下面是页面跳转逻辑
            // 跳转到指定页码
            gotoPage(page = this.page, patch = this.patch) {
                if (page === "...") return;
                if (page >= 1 && page <= this.totalPages) {
                    this.currentPage = page;
                    axios
                        .get(this.historyDataURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {
                                searchType: this.isAll,
                                source: this.sourceSelect,
                                brand: this.brandSelect,
                                model: this.modelSelect,
                                color: this.colorSelect,
                                grade: this.gradeSelect,
                                capacity: this.capacitySelect,
                                transactionPriceStart: this.lowpriceSelect,
                                transactionPriceEnd: this.highpriceSelect,
                                isSuccess: this.buysuccessSelect,
                                //patch: patch,
                                pageNo: this.currentPage,
                                pageSize: this.itemsPerPage,
                                // authorization: "转转个人"
                            },
                        })
                        .then((response) => {
                            this.data = response.data;
                            this.allpages = response.data.data.totalPages;
                            // 输出响应数据
                        })
                        .catch((error) => {
                            this.data = error;
                            console.error("获取数据出错:", error);
                        });
                }
            },
            // 上一页
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },
            // 下一页
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },
            // 跳转指定页
            gotoSpecificPage() {
                if (this.gotoPageNumber >= 1 && this.gotoPageNumber <= this.totalPages) {
                    this.currentPage = this.gotoPageNumber;
                    this.gotoPage(this.currentPage);
                } else {
                    alert(`请输入1到${this.totalPages}之间的页码`);
                }
            },

            showtimeAlert() {
                // 返回警告框的内容
                return alert("当前拍卖场次还未开放,请耐心等待..");
            },

            // 查找失败弹窗
            shownofoundAlert() {
                // 返回警告框的内容
                return alert("没有查询到相关信息,请刷新页面或重置筛选条件..");
            },

            // 下面是菜单筛选函数
            // 初始化筛选条件
            getselectData() {
                axios
                    .get(this.historyMenuURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            //patch: patch,
                            searchType: this.isAll,
                        },
                    })
                    .then((response) => {
                        this.selectdata = response.data;
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },

            // 重置品牌
            resetbrand() {
                this.modelSelect = null;
                this.colorSelect = null;
                this.capacitySelect = null;
            },

            // 重置筛选条件
            resetSelection() {
                delete this.urlCarry;
                this.sourceSelect = null;
                this.gradeSelect = null;
                if (typeof this.urlCarry !== "undefined") {
                    return;
                }
                this.brandSelect = null;
                this.modelSelect = null;
                this.colorSelect = null;
                this.capacitySelect = null;
                this.lowpriceSelect = null;
                this.highpriceSelect = null;
                this.conditonSelect = null;
                this.buysuccessSelect = null;

                // this.selectdata = null;
                // this.selectsource=null;

                this.selectbrand = null;
                this.selectmodel = null;
                this.selectbasicinfo = null;
            },

            // 根据品牌展示型号
            setmodel() {
                this.resetbrand();
                axios
                    .get(this.historyMenuURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            searchType: this.isAll,
                            brand: this.brandSelect,
                            patch: this.patch,
                        },
                    })
                    .then((response) => {
                        this.selectbrand = response.data;

                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 根据 型号展示基本信息
            setbasicinfo() {
                axios
                    .get(this.historyMenuURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            searchType: this.isAll,
                            source: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            patch: this.patch,
                        },
                    })
                    .then((response) => {
                        this.selectbasicinfo = response.data;
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },

            // 上面是菜单筛选函数

            // 初始化采货数据
            getinitData() {
                this.resetSelection();
                var jk = this.selectPara(1);
                axios
                    .get(this.historyDataURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: jk,
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.getselectData();
                        this.allpages = response.data.data.totalPages;
                        this.resetSelection();
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.data = error;
                    });
            },

            // 按照条件筛选出采货数据
            menuselect(pageNo = 1) {
                // patch 只在暗拍间隙生效
                var jk = this.selectPara(pageNo);

                if (this.lowpriceSelect && this.highpriceSelect && this.lowpriceSelect >= this.highpriceSelect) {
                    alert("最低成交价必须小于最高成交价");
                    return;
                }

                axios
                    .get(this.historyDataURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: jk,
                        async: false,
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.currentPage = 1;
                        //this.getselectData()
                        this.allpages = response.data.data.totalPages;
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            selectPara(pageNo = 1) {
                var mw = this.urlCarry;

                if (typeof this.urlCarry !== "undefined" && this.urlCarry !== null) {
                    // 创建 XMLHttpRequest 对象
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", `${this.historyDataURL}?stickCode=${mw}`, false); // 第三个参数 false 表示同步请求
                    xhr.setRequestHeader("satoken", localStorage.sa); // 设置请求头

                    xhr.onload = function () {
                        if (xhr.status === 200) {
                            var response = JSON.parse(xhr.responseText);
                            var te = response.data.result[0];
                            if (typeof te === "undefined") {
                                ElMessage.error("没有找到相关信息！");
                                this.$router.push({ path: "/purhistory" });
                                return;
                            }
                            this.brandSelect = te.brand;
                            this.modelSelect = te.model;
                            this.colorSelect = te.color;
                            this.gradeSelect = te.select;
                            if (typeof te.ram === "undefined") {
                                this.capacitySelect = te.storage;
                            } else {
                                this.capacitySelect = te.ram + "+" + te.storage;
                            }
                            return {
                                searchType: this.isAll,
                                pageNo: pageNo,
                                pageSize: this.itemsPerPage,

                                source: this.sourceSelect,
                                brand: this.brandSelect,
                                model: this.modelSelect,
                                color: this.colorSelect,
                                grade: this.gradeSelect,
                                capacity: this.capacitySelect,
                                transactionPriceStart: this.lowpriceSelect,
                                transactionPriceEnd: this.highpriceSelect,
                                isSuccess: this.buysuccessSelect,
                            };
                        } else {
                        }
                    }.bind(this);

                    xhr.onerror = function () {};

                    xhr.send();
                }

                return {
                    searchType: this.isAll,
                    pageNo: pageNo,
                    pageSize: this.itemsPerPage,

                    source: this.sourceSelect,
                    brand: this.brandSelect,
                    model: this.modelSelect,
                    color: this.colorSelect,
                    grade: this.gradeSelect,
                    capacity: this.capacitySelect,
                    transactionPriceStart: this.lowpriceSelect,
                    transactionPriceEnd: this.highpriceSelect,
                    isSuccess: this.buysuccessSelect,
                };
            },

            // 数字框禁止输入科学计数
            preventE(event) {
                // 禁止输入 'e', 'E', '+', '-'
                if (event.key === "e" || event.key === "E" || event.key === "+" || event.key === "-") {
                    event.preventDefault();
                }
            },

            // 处理 \"
            parseDefectUrls(defectUrl) {
                try {
                    const urls = JSON.parse(defectUrl);
                    return Object.values(urls);
                } catch (e) {
                    return [];
                }
            },
            // 处理 \"
            parseQualityDesc(desc) {
                try {
                    const quality = JSON.parse(desc);
                    let result = "";
                    for (let key in quality) {
                        result += `${key}: ${quality[key]} `;
                    }
                    return result.trim();
                } catch (e) {
                    return desc;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    // 下面是自定义下拉框样式
    /* CSS样式 */
    .custom-select {
        // 显示出滚动条
        position: relative;
        width: 150px;
        /* 调整选择框的宽度 */
        margin-right: 20px;
    }

    .custom-select input {
        display: flex;
        width: 100%;
        padding: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        background-color: #fff;
    }

    .custom-select .options {
        // 绝对展示--不干扰其他元素位置
        position: absolute;
        display: none;
        width: 100%;
        /* 调整下拉选项的最大高度 */
        max-height: 290px;
        overflow-y: auto;
        border: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }

    .custom-select .option {
        display: flex;
        /* 允许换行 */
        white-space: normal;
        /* 选项文字不换行*/
        white-space: nowrap;
        /* 长单词换行 */
        //word-wrap: break-word;
        color: #204d74;
        cursor: pointer;
    }

    .custom-select .option:hover {
        background-color: #f0f0f0;
    }

    .custom-select.open .options {
        display: block;
    }

    // 上面是自定义下拉框样式

    /* CSS 样式，用于弹窗外观 */
    .overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* 半透明黑色背景 */
        z-index: 9999;
        /* 弹窗位于最上层 */
    }

    .popup {
        overflow: auto;
        position: fixed;
        background-color: white;
        height: 95%;
        width: 70%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        /* 确保弹窗在黑色背景之上 */
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }

    // MIXINS
    @mixin bp-sm {
        @media (min-width: 40.625em) {
            @content;
        }
    }

    @mixin bp-md {
        @media (min-width: 48em) {
            @content;
        }
    }

    @mixin bp-lg {
        @media (min-width: 62em) {
            @content;
        }
    }

    @mixin pseudo-starter {
        content: "";
        display: block;
    }

    .shortcut-box {
        width: 100%;
        // 悬停样式变化
        transition: all 300ms ease, transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);

        // 页面颜色
        --color-brand-primary: hsl(var(--color-brand-primary-h), 43%, 43%);
        --color-brand-primary-h: 251;
        --color-brand-primary-s: 43%;
        --color-brand-primary-l: 43%;
        --color-brand-accent: hsl(var(--color-brand-accent-h), 96%, 61%);
        --color-brand-accent-h: 16;
        --color-brand-accent-s: 96%;
        --color-brand-accent-l: 61%;
        --color-brand-accent-bg: hsl(calc(var(--color-brand-accent-h) + 17), 100%, 96%);

        // 页面排列（排版）
        // The ratio number
        --ratio: 1.4;

        //小尺寸
        --s-6: calc(var(--s-5) / var(--ratio));
        --s-5: calc(var(--s-4) / var(--ratio));
        --s-4: calc(var(--s-3) / var(--ratio));
        --s-3: calc(var(--s-2) / var(--ratio));
        --s-2: calc(var(--s-1) / var(--ratio));
        --s-1: calc(var(--s0) / var(--ratio));
        --s0: calc(1.05rem + 0.333vw);

        // 大尺寸
        --s1: calc(var(--s0) * var(--ratio));
        --s2: calc(var(--s1) * var(--ratio));
        --s3: calc(var(--s2) * var(--ratio));
        --s4: calc(var(--s3) * var(--ratio));
        --s5: calc(var(--s4) * var(--ratio));
        --s6: calc(var(--s5) * var(--ratio));
        line-height: 1.6;
        box-sizing: border-box;

        background-color: rgba(16 18 27 / 10%);
        overflow-x: hidden;
        @include bp-sm {
            --s0: calc(1.25rem + 0.333vw);
        }

        @include bp-md {
            --s0: calc(1.4rem + 0.333vw);
        }

        @include bp-lg {
            --s0: calc(0.9rem + 0.333vw);
        }
    }

    .section {
        //padding: 0 var(--s3);
        padding: 20px 40px;

        .header {
            height: 330px;
            color: #ffffff;
            display: flex;
            flex-wrap: wrap;
            z-index: -1;
            background-attachment: fixed;

            span {
                display: flex;
                flex-direction: column;
                width: 60%;

                h2 {
                    font-size: 2.5rem;
                    font-weight: 500;
                    margin: 0;
                }

                h6 {
                    font-size: 1rem;
                    font-weight: 350;
                    margin: 14px 0 0;
                }
            }
        }
    }

    h2,
    h3,
    p,
    ul {
        margin: 0;
    }

    // 展示数据样式
    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;

            &:before {
                content: "\200B";
                /* 添加任意空间 */
                clip: rect(0 0 0 0);
                height: 1px;
                width: 1px;
                position: absolute;
            }
        }
    }

    .services {
        grid-gap: var(--s2);
        margin: 0 calc(var(--s3) * -1);
        padding: var(--s6) var(--s3);
        position: relative;
        z-index: 1;
        @include bp-sm {
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: minmax(100px, 1fr);
        }

        @include bp-sm {
            padding: 0 var(--s3);
        }

        &__item {
            background: #fff;
            padding: calc(var(--s2) - 0.6rem) var(--s1);
            border-radius: 25px;
            box-shadow: 0 7px 20px rgba(100, 28, 2, 0.135);

            @include bp-sm {
                transform: translateY(-85px);
            }

            @include bp-md {
                transform: translateY(-130px);
            }

            h3 {
                color: var(--color-brand-primary);
                font-size: var(--s1);
                line-height: 1.2;
            }

            &:after {
                @include pseudo-starter;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 50px;
                height: 50px;
                border-radius: 25px 0;
                cursor: pointer;
                transition: inherit;
                background-color: var(--color-brand-accent);
                background-size: 20px 20px;
                background-repeat: no-repeat;
                background-position: center;
                //todo 精灵图将右下角换为各个平台的 logo
                background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjZmZmZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHg9IjBweCIgeT0iMHB4Ij48dGl0bGU+NTI8L3RpdGxlPjxwYXRoIGQ9Ik04MS4zMDMyOSwzOC41MjkzOUExNC4wMTgsMTQuMDE4LDAsMSwwLDYxLjQ3NywxOC43MDY3MUw0Ny4wMDMxNSwzMy4xNzkxNGExNC4wMzAzNywxNC4wMzAzNywwLDAsMCwwLDE5LjgyMTcxLDQuODAxMTMsNC44MDExMywwLDAsMS02Ljc4OTc5LDYuNzg5ODcsMjMuNjQzMjcsMjMuNjQzMjcsMCwwLDEsMC0zMy40MDE0NUw1NC42ODcyMSwxMS45MTY4NEEyMy42MjAzLDIzLjYyMDMsMCwwLDEsODguMDkzMDgsNDUuMzE5MjdMODAuOTIzOCw1Mi40ODcxMWE0LjgwMTE0LDQuODAxMTQsMCwwLDEtNi43ODk4LTYuNzg5ODdaTTExLjkwNzQxLDg4LjA5MzlhMjMuNjUwNTMsMjMuNjUwNTMsMCwwLDAsMzMuNDA1ODYtLjAwMUw1OS43ODY2NCw3My42MjE0N2EyMy42MTU4MywyMy42MTU4MywwLDAsMCwwLTMzLjQwMTQ1LDQuODAxMTQsNC44MDExNCwwLDAsMC02Ljc4OTc5LDYuNzg5ODgsMTQuMDE1MzEsMTQuMDE1MzEsMCwwLDEsMCwxOS44MjI2OEwzOC41MjM0OCw4MS4zMDRBMTQuMDE4LDE0LjAxOCwwLDEsMSwxOC42OTcyLDYxLjQ4MTM1TDI1Ljg2Niw1NC4zMTM1YTQuODAxMTQsNC44MDExNCwwLDAsMC02Ljc4OTgtNi43ODk4N2wtNy4xNjg3OSw3LjE2Nzg1QTIzLjY0NDg5LDIzLjY0NDg5LDAsMCwwLDExLjkwNzQxLDg4LjA5MzlaIj48L3BhdGg+PC9zdmc+");
            }

            p {
                margin-top: var(--s-1);
                font-weight: 400;
                color: hsl(250deg, 7%, 46%);
            }

            &:hover {
                background-color: var(--color-brand-accent);

                h3 {
                    color: #fff;
                }

                p {
                    color: hsla(0, 0%, 100%, 0.8);
                }

                &:after {
                    background-color: #fff;
                    background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjZmI2ZjNjIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHg9IjBweCIgeT0iMHB4Ij48dGl0bGU+NTI8L3RpdGxlPjxwYXRoIGQ9Ik04MS4zMDMyOSwzOC41MjkzOUExNC4wMTgsMTQuMDE4LDAsMSwwLDYxLjQ3NywxOC43MDY3MUw0Ny4wMDMxNSwzMy4xNzkxNGExNC4wMzAzNywxNC4wMzAzNywwLDAsMCwwLDE5LjgyMTcxLDQuODAxMTMsNC44MDExMywwLDAsMS02Ljc4OTc5LDYuNzg5ODcsMjMuNjQzMjcsMjMuNjQzMjcsMCwwLDEsMC0zMy40MDE0NUw1NC42ODcyMSwxMS45MTY4NEEyMy42MjAzLDIzLjYyMDMsMCwwLDEsODguMDkzMDgsNDUuMzE5MjdMODAuOTIzOCw1Mi40ODcxMWE0LjgwMTE0LDQuODAxMTQsMCwwLDEtNi43ODk4LTYuNzg5ODdaTTExLjkwNzQxLDg4LjA5MzlhMjMuNjUwNTMsMjMuNjUwNTMsMCwwLDAsMzMuNDA1ODYtLjAwMUw1OS43ODY2NCw3My42MjE0N2EyMy42MTU4MywyMy42MTU4MywwLDAsMCwwLTMzLjQwMTQ1LDQuODAxMTQsNC44MDExNCwwLDAsMC02Ljc4OTc5LDYuNzg5ODgsMTQuMDE1MzEsMTQuMDE1MzEsMCwwLDEsMCwxOS44MjI2OEwzOC41MjM0OCw4MS4zMDRBMTQuMDE4LDE0LjAxOCwwLDEsMSwxOC42OTcyLDYxLjQ4MTM1TDI1Ljg2Niw1NC4zMTM1YTQuODAxMTQsNC44MDExNCwwLDAsMC02Ljc4OTgtNi43ODk4N2wtNy4xNjg3OSw3LjE2Nzg1QTIzLjY0NDg5LDIzLjY0NDg5LDAsMCwwLDExLjkwNzQxLDg4LjA5MzlaIj48L3BhdGg+PC9zdmc+");
                }
            }
        }
    }

    // 搜索菜单栏样式
    .person-info {
        width: 100%;
        overflow: visible;
        align-items: center;
        background-color: rgba(16 18 27 / 10%);
        padding: 20px 40px;
        color: #ffffff;

        .contact-me {
            // display: flex;
            flex-direction: column;
            width: 100%;
            overflow: visible;

            .text-center-row {
                // display: flex;
                flex-wrap: wrap;
                width: 100%;

                .row {
                    .form-group {
                        .input-group {
                            display: flex;
                            flex-direction: row;

                            padding-left: 20px;
                            height: 38px;
                            width: 100%;
                            margin-bottom: 10px;
                        }
                    }

                    .input {
                        width: 100%;
                        margin-right: 30px;
                        border-radius: 2px;
                        border: 1px solid #ccc;
                    }

                    .input1 {
                        padding: 10px;
                        border-radius: 4px;
                    }

                    .input:focus {
                        border-color: #66afe9;
                        outline: 0;
                        box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
                    }

                    @media screen and (max-width: 1110px) {
                        width: 100%;
                    }
                }
            }

            .button {
                .btn {
                    padding: 8px 30px;
                    border-radius: 6px;
                    background-color: #007bff;
                    border-color: #2e6da4;
                    color: #ffffff;
                    font-weight: 500;
                    margin: 20px;
                }

                .btn:hover {
                    background-color: #0056b3;
                    border-color: #204d74;
                }
            }
        }
    }

    /* 分页样式 下面 */
    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .pagination ul {
        display: flex;
        list-style-type: none;
        padding: 0;
    }

    .pagination ul li {
        margin: 0 5px;
    }

    .pagination ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .pagination ul li.page-item a {
        text-decoration: none;
        padding: 5px 10px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: #f5f5f5;
    }

    .pagination ul li.page-item a:hover {
        background-color: #e9ecef;
    }

    .pagination ul li.page-item.active a {
        background-color: #007bff;
        color: white;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.histop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -56px;
        left: 130px;
    }

    :deep(.histop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -47px;
        left: 216px;
    }

    /* 可选：自定义分页样式 上面 */
</style>
